/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/prod_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zM26 26H6V6h20v20z"/><path pid="1" d="M16.323 15.27a2.99 2.99 0 002.121-.879l6.568-6.545L25 7h-7.5l-3.298 3.148a2.998 2.998 0 000 4.242c.586.587 1.354.88 2.121.88zm-.312-3.688a1 1 0 110 2 1 1 0 010-2zM13.958 21.877l.707-.707-1.238-1.236 1.352-1.352h2.479l1.34 1.352-1.229 1.238.711.705 1.578-1.592a.503.503 0 000-.705l-1.646-1.66-.336-.338H17.012v-1.82c-.609.188-1.5.107-2-.08v1.9h-.647l-.354.354-1.645 1.646a.5.5 0 000 .708l1.592 1.587z"/>'
  }
})
